<template>
  <content-subpage
    :visible="visible"
    :titles="titles"
    :content-title="t('tinymce_plugin_text_to_speech_content_subpage_title')"
    class="text-to-speech-content-subpage"
    @content-subpage-hidden="actionHidden"
  >
    <template #main-content>
      <div class="tts-content">
        <TextToSpeech
          :audio-uuid="params.audioUuid"
          :audio-text="params.audioText"
          :in-multi-line="true"
        />
      </div>
    </template>
  </content-subpage>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useI18n } from "vue-i18n";
import { useContentSubpage } from "@plugins/content-subpage/composables/content-subpage.ts";
import ContentSubpage from "@plugins/content-subpage/components/ContentSubpage.vue";

defineOptions({ name: "TextToSpeechContentSubpage" });

const TextToSpeech = defineAsyncComponent(() => import("./TextToSpeech.vue"));

const props = defineProps<{
  params: { audioUuid: string; audioText: string };
}>();

const { t } = useI18n();

const { visible, titles, actionHidden, removeDirty, defaultExpose } = useContentSubpage();

titles.value.push(t("tinymce_plugin_text_to_speech_content_subpage_title"));

defineExpose({
  visible,
  titles,
  actionHidden,
  removeDirty,
  ...defaultExpose,
});

const params = props.params;
</script>
